var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVect4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41974 0.664007C6.9143 0.849707 4.52342 1.83231 2.91717 3.33642C1.56373 4.60378 0.880933 6.05116 0.875041 7.66544C0.869021 9.31716 1.5325 10.7481 2.9069 12.0477L3.43681 12.5488L3.12215 14.1376C2.9491 15.0114 2.81801 15.7368 2.83081 15.7496C2.84367 15.7624 3.86001 15.4622 5.08938 15.0825L7.32471 14.392L8.05382 14.533C10.5709 15.0195 13.2877 14.7264 15.5095 13.7287C20.4345 11.5171 21.6282 6.66959 18.0686 3.33642C15.9914 1.3914 12.8213 0.411849 9.41974 0.664007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVect4);
export default __webpack_public_path__ + "static/media/vect4.444aeafd4c382d1b71b04f684ee81efd.svg";
export { ForwardRef as ReactComponent };